<template>
  <div>
    <h1>404</h1>

    <h2>{{ title }}</h2>

    <div
      v-for="(link, index) in links"
      :key="index"
      @click="goTo(link.componant.name)"
    >
      {{ link.text }}
    </div>
  </div>
</template>

<script>
import goTo from "../../mixins/goTo";
const acceptedTypeNames = ["blogs", "products", "providers"];
const defaultTypeName = "unknown";

export default {
  mixins: [goTo],
  props: {
    type: {
      type: String,
      default: defaultTypeName,
    },
  },
  computed: {
    title() {
      return this.$i18n.t("common.notFound.title");
    },
    links() {
      const typeName =
        acceptedTypeNames.indexOf(this.type) !== -1
          ? this.type
          : defaultTypeName;

      return this.$i18n.t(`common.notFound.type.${typeName}.links`);
    },
  },
};
</script>
